/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Sms_session$ref = any;
export type routePropsSubscriptionsSms_QueryVariables = {||};
export type routePropsSubscriptionsSms_QueryResponse = {|
  +my_portal_session: ?{|
    +authorized_sms_notifications: boolean,
    +$fragmentRefs: Sms_session$ref,
  |}
|};
export type routePropsSubscriptionsSms_Query = {|
  variables: routePropsSubscriptionsSms_QueryVariables,
  response: routePropsSubscriptionsSms_QueryResponse,
|};
*/


/*
query routePropsSubscriptionsSms_Query {
  my_portal_session {
    authorized_sms_notifications
    ...Sms_session
    id
  }
}

fragment AuthFormProvider_session on MyPortal__Session {
  id
  auth_sent
  can_resend_auth
  authorization_unauthorized_page_description_label
  authorization_unauthorized_page_heading: i18n_config_t(key: "myportal.config.authorization.unauthorized.page_heading")
  authorization_unauthorized_have_not_recieved_an_email: i18n_config_t(key: "myportal.config.authorization.unauthorized.have_not_recieved_an_email")
  authorization_unauthorized_actions_send_again: i18n_config_t(key: "myportal.config.authorization.unauthorized.actions.send_again")
}

fragment SmsPhoneForm_session on MyPortal__Session {
  id
  portal_person {
    id
    sms_phone {
      ...SmsPhone_sms_phone
      id
    }
  }
  label_global_busy_saving: i18n(key: "global.busy.saving")
  label_action_save: i18n(key: "global.actions.save")
  label_action_cancel: i18n(key: "global.actions.cancel")
  sms_phone_label_phone_number: i18n(key: "myportal.client.subscriptions.sms.phone_number_label")
  sms_phone_form_label_message_phone_invalid_number: i18n_config_t(key: "myportal.config.subscriptions.sms.messages.phone_invalid_number")
}

fragment SmsPhoneForm_sms_phone on MyPortal__SmsPhone {
  id
  errors {
    attribute
    error
  }
  phone_number
  subscribe_status
  subscribe_title
  subscribe_description
}

fragment SmsPhone_session on MyPortal__Session {
  id
  has_user_authorized
  ...SmsPhoneForm_session
  label_action_edit: i18n(key: "global.actions.edit")
  sms_phone_label_phone_number: i18n(key: "myportal.client.subscriptions.sms.phone_number_label")
  sms_phone_label_status: i18n(key: "myportal.client.subscriptions.sms.status_label")
  sms_phone_label_subscribe: i18n_config_t(key: "myportal.config.subscriptions.sms.actions.subscribe")
  sms_phone_label_unsubscribe: i18n_config_t(key: "myportal.config.subscriptions.sms.actions.unsubscribe")
  sms_phone_label_resend_verification: i18n_config_t(key: "myportal.config.subscriptions.sms.actions.resend_verification")
  sms_phone_message_phone_invalid_number: i18n_config_t(key: "myportal.config.subscriptions.sms.messages.phone_invalid_number")
  sms_phone_message_verification_success: i18n_config_t(key: "myportal.config.subscriptions.sms.messages.verification_success")
  sms_phone_message_unsubscribe_success: i18n_config_t(key: "myportal.config.subscriptions.sms.messages.unsubscribe_success")
  sms_phone_message_subscribe_success: i18n_config_t(key: "myportal.config.subscriptions.sms.messages.subscribe_success")
}

fragment SmsPhone_sms_phone on MyPortal__SmsPhone {
  id
  ...SmsPhoneForm_sms_phone
  phone_number
  subscribe_status
  subscribe_title
  subscribe_description
  sms_instructions
}

fragment Sms_session on MyPortal__Session {
  id
  has_user_authorized
  portal_person {
    id
    sms_feature_enabled
    has_match
    sms_phone {
      id
      ...SmsPhone_sms_phone
    }
  }
  ...AuthFormProvider_session
  ...SmsPhone_session
  label_sms_heading: i18n_config_t(key: "myportal.config.subscriptions.sms.page_heading")
  label_sms_description: i18n_config_t(key: "myportal.config.subscriptions.sms.page_description")
  global_errors_no_records_found: i18n(key: "global.errors.no_records_found")
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authorized_sms_notifications",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "key",
    "value": "myportal.config.subscriptions.sms.messages.phone_invalid_number"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "routePropsSubscriptionsSms_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MyPortal__Session",
        "kind": "LinkedField",
        "name": "my_portal_session",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Sms_session"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "routePropsSubscriptionsSms_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MyPortal__Session",
        "kind": "LinkedField",
        "name": "my_portal_session",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "has_user_authorized",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MyPortal__PortalPerson",
            "kind": "LinkedField",
            "name": "portal_person",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sms_feature_enabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "has_match",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MyPortal__SmsPhone",
                "kind": "LinkedField",
                "name": "sms_phone",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CommonModelError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attribute",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "error",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phone_number",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscribe_status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscribe_title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscribe_description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sms_instructions",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "auth_sent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "can_resend_auth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "authorization_unauthorized_page_description_label",
            "storageKey": null
          },
          {
            "alias": "authorization_unauthorized_page_heading",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.authorization.unauthorized.page_heading"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.authorization.unauthorized.page_heading\")"
          },
          {
            "alias": "authorization_unauthorized_have_not_recieved_an_email",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.authorization.unauthorized.have_not_recieved_an_email"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.authorization.unauthorized.have_not_recieved_an_email\")"
          },
          {
            "alias": "authorization_unauthorized_actions_send_again",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.authorization.unauthorized.actions.send_again"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.authorization.unauthorized.actions.send_again\")"
          },
          {
            "alias": "label_global_busy_saving",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "global.busy.saving"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n",
            "storageKey": "i18n(key:\"global.busy.saving\")"
          },
          {
            "alias": "label_action_save",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "global.actions.save"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n",
            "storageKey": "i18n(key:\"global.actions.save\")"
          },
          {
            "alias": "label_action_cancel",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "global.actions.cancel"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n",
            "storageKey": "i18n(key:\"global.actions.cancel\")"
          },
          {
            "alias": "sms_phone_label_phone_number",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.client.subscriptions.sms.phone_number_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n",
            "storageKey": "i18n(key:\"myportal.client.subscriptions.sms.phone_number_label\")"
          },
          {
            "alias": "sms_phone_form_label_message_phone_invalid_number",
            "args": (v2/*: any*/),
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.sms.messages.phone_invalid_number\")"
          },
          {
            "alias": "label_action_edit",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "global.actions.edit"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n",
            "storageKey": "i18n(key:\"global.actions.edit\")"
          },
          {
            "alias": "sms_phone_label_status",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.client.subscriptions.sms.status_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n",
            "storageKey": "i18n(key:\"myportal.client.subscriptions.sms.status_label\")"
          },
          {
            "alias": "sms_phone_label_subscribe",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.sms.actions.subscribe"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.sms.actions.subscribe\")"
          },
          {
            "alias": "sms_phone_label_unsubscribe",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.sms.actions.unsubscribe"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.sms.actions.unsubscribe\")"
          },
          {
            "alias": "sms_phone_label_resend_verification",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.sms.actions.resend_verification"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.sms.actions.resend_verification\")"
          },
          {
            "alias": "sms_phone_message_phone_invalid_number",
            "args": (v2/*: any*/),
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.sms.messages.phone_invalid_number\")"
          },
          {
            "alias": "sms_phone_message_verification_success",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.sms.messages.verification_success"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.sms.messages.verification_success\")"
          },
          {
            "alias": "sms_phone_message_unsubscribe_success",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.sms.messages.unsubscribe_success"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.sms.messages.unsubscribe_success\")"
          },
          {
            "alias": "sms_phone_message_subscribe_success",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.sms.messages.subscribe_success"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.sms.messages.subscribe_success\")"
          },
          {
            "alias": "label_sms_heading",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.sms.page_heading"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.sms.page_heading\")"
          },
          {
            "alias": "label_sms_description",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.sms.page_description"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.sms.page_description\")"
          },
          {
            "alias": "global_errors_no_records_found",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "global.errors.no_records_found"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n",
            "storageKey": "i18n(key:\"global.errors.no_records_found\")"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bd50e155a814d8a7ab5407d7845fdc16",
    "id": null,
    "metadata": {},
    "name": "routePropsSubscriptionsSms_Query",
    "operationKind": "query",
    "text": "query routePropsSubscriptionsSms_Query {\n  my_portal_session {\n    authorized_sms_notifications\n    ...Sms_session\n    id\n  }\n}\n\nfragment AuthFormProvider_session on MyPortal__Session {\n  id\n  auth_sent\n  can_resend_auth\n  authorization_unauthorized_page_description_label\n  authorization_unauthorized_page_heading: i18n_config_t(key: \"myportal.config.authorization.unauthorized.page_heading\")\n  authorization_unauthorized_have_not_recieved_an_email: i18n_config_t(key: \"myportal.config.authorization.unauthorized.have_not_recieved_an_email\")\n  authorization_unauthorized_actions_send_again: i18n_config_t(key: \"myportal.config.authorization.unauthorized.actions.send_again\")\n}\n\nfragment SmsPhoneForm_session on MyPortal__Session {\n  id\n  portal_person {\n    id\n    sms_phone {\n      ...SmsPhone_sms_phone\n      id\n    }\n  }\n  label_global_busy_saving: i18n(key: \"global.busy.saving\")\n  label_action_save: i18n(key: \"global.actions.save\")\n  label_action_cancel: i18n(key: \"global.actions.cancel\")\n  sms_phone_label_phone_number: i18n(key: \"myportal.client.subscriptions.sms.phone_number_label\")\n  sms_phone_form_label_message_phone_invalid_number: i18n_config_t(key: \"myportal.config.subscriptions.sms.messages.phone_invalid_number\")\n}\n\nfragment SmsPhoneForm_sms_phone on MyPortal__SmsPhone {\n  id\n  errors {\n    attribute\n    error\n  }\n  phone_number\n  subscribe_status\n  subscribe_title\n  subscribe_description\n}\n\nfragment SmsPhone_session on MyPortal__Session {\n  id\n  has_user_authorized\n  ...SmsPhoneForm_session\n  label_action_edit: i18n(key: \"global.actions.edit\")\n  sms_phone_label_phone_number: i18n(key: \"myportal.client.subscriptions.sms.phone_number_label\")\n  sms_phone_label_status: i18n(key: \"myportal.client.subscriptions.sms.status_label\")\n  sms_phone_label_subscribe: i18n_config_t(key: \"myportal.config.subscriptions.sms.actions.subscribe\")\n  sms_phone_label_unsubscribe: i18n_config_t(key: \"myportal.config.subscriptions.sms.actions.unsubscribe\")\n  sms_phone_label_resend_verification: i18n_config_t(key: \"myportal.config.subscriptions.sms.actions.resend_verification\")\n  sms_phone_message_phone_invalid_number: i18n_config_t(key: \"myportal.config.subscriptions.sms.messages.phone_invalid_number\")\n  sms_phone_message_verification_success: i18n_config_t(key: \"myportal.config.subscriptions.sms.messages.verification_success\")\n  sms_phone_message_unsubscribe_success: i18n_config_t(key: \"myportal.config.subscriptions.sms.messages.unsubscribe_success\")\n  sms_phone_message_subscribe_success: i18n_config_t(key: \"myportal.config.subscriptions.sms.messages.subscribe_success\")\n}\n\nfragment SmsPhone_sms_phone on MyPortal__SmsPhone {\n  id\n  ...SmsPhoneForm_sms_phone\n  phone_number\n  subscribe_status\n  subscribe_title\n  subscribe_description\n  sms_instructions\n}\n\nfragment Sms_session on MyPortal__Session {\n  id\n  has_user_authorized\n  portal_person {\n    id\n    sms_feature_enabled\n    has_match\n    sms_phone {\n      id\n      ...SmsPhone_sms_phone\n    }\n  }\n  ...AuthFormProvider_session\n  ...SmsPhone_session\n  label_sms_heading: i18n_config_t(key: \"myportal.config.subscriptions.sms.page_heading\")\n  label_sms_description: i18n_config_t(key: \"myportal.config.subscriptions.sms.page_description\")\n  global_errors_no_records_found: i18n(key: \"global.errors.no_records_found\")\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a0cf7bb4e376d65440bb7e59b3d49e5b';

module.exports = node;
